/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { CreateAdobeApprovalContainer as CreateAdobeApproval } from './CreateAdobeApproval.container';
